<template>
    <vx-card title="Редактирование алерта" id="loader" class="alerts-management-edit">
        <h5 class="mt-5">Основное</h5>
        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="form.name"
                        :danger="!!errors.name"
                        :danger-text="errors.name"
                        autocomplete="off"
                        label="Название"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="form.description"
                        :danger="!!errors.description"
                        :danger-text="errors.description"
                        autocomplete="off"
                        label="Описание"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="form.title"
                        :danger="!!errors.title"
                        :danger-text="errors.title"
                        autocomplete="off"
                        label="Заголовок"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <div class="vx-row mb-2">
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.checkFrequency"
                        :danger="!!errors.checkFrequency"
                        :danger-text="errors.checkFrequency"
                        autocomplete="off"
                        label="Частота проверки, минут"
                        class="mt-1 w-full required"/>
                </div>
            </div>
            <div class="vx-col w-1/2">
                <div class="mt-1">
                    <vs-input
                        v-model="form.checkPeriod"
                        :danger="!!errors.checkPeriod"
                        :danger-text="errors.checkPeriod"
                        autocomplete="off"
                        label="Период проверки, минут"
                        class="mt-1 w-full required"/>
                </div>
            </div>
        </div>

        <h5 class="mt-5">Значения алерта</h5>
        <vs-table :data="form.alertParams">
            <template #thead>
                <vs-th> Название </vs-th>
                <vs-th> Описание </vs-th>
                <vs-th> Значение</vs-th>
                <vs-th> Единица измерения</vs-th>
                <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <vs-input v-model="tr.name" disabled
                            :danger="!!errors[`alertParams[${indextr}].Name`]"
                            :danger-text="!!errors[`alertParams[${indextr}].Name`] ? errors[`alertParams[${indextr}].Name`][0] : ''"
                            autocomplete="off" class="w-full required mb-4"
                            @input="errors[`alertParams[${indextr}].Name`] = ''" />
                    </vs-td>
                    <vs-td>
                        <vs-input v-model="tr.description"
                            :danger="!!errors[`alertParams[${indextr}].Description`]"
                            :danger-text="!!errors[`alertParams[${indextr}].Description`] ? errors[`alertParams[${indextr}].Description`][0] : ''"
                            autocomplete="off" class="w-full required mb-4"
                            @input="errors[`alertParams[${indextr}].Description`] = ''" />
                    </vs-td>
                    <vs-td>
                        <vs-input v-model="tr.value"
                            :danger="!!errors[`alertParams[${indextr}].Value`]"
                            :danger-text="!!errors[`alertParams[${indextr}].Value`] ? errors[`alertParams[${indextr}].Value`][0] : ''"
                            autocomplete="off" class="w-full mb-4"
                            @input="errors[`alertParams[${indextr}].Value`] = ''" /> 
                    </vs-td>
                    <vs-td>
                        <div class="relative mb-4">
                            <v-select v-model="tr.unitId" disabled :options="dicts.alertParamUnits" class="w-full"
                                v-bind:class="{ 'select-error': !!errors[`alertParams[${indextr}].UnitId`] }" label="name"
                                placeholder="Выберите единицу измерения" :reduce="opt => opt.id"
                                append-to-body @input="errors[`alertParams[${indextr}].UnitId`] = ''" />
                            <div v-if="errors[`alertParams[${indextr}].UnitId`]"
                                class="con-text-validation span-text-validation-danger vs-input--text-validation-span select-validation">
                                <span class="span-text-validation">
                                    {{ errors[`alertParams[${indextr}].UnitId`][0] }}
                                </span>
                            </div>
                        </div> 
                    </vs-td>
                    <vs-td class="action-col">
                        <!--<div v-if="!tr.required" class="inline-block cursor-pointer mt-2 mr-3 mb-4">
                            <feather-icon @click="deleteParam(indextr)" icon="Trash2Icon"
                                class="inline-block text-danger" svgClasses="w-6 h-6" />
                        </div> -->
                    </vs-td> 
                </vs-tr>
                <!-- <vs-tr>
                    <vs-td colspan="5">
                        <vs-button class="" @click="addNewParam">
                            <feather-icon icon="PlusIcon" class="inline-block text-white" svgClasses="w-6 h-6" />
                        </vs-button>
                    </vs-td>
                </vs-tr> -->
            </template>
        </vs-table>

        <h5 class="mt-5">Чаты для отправки</h5>
        <vs-table :data="form.alertTransports">
            <template #thead>
                <vs-th class="vs-lg-6"> Название </vs-th>
                <vs-th class="vs-lg-6"></vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="relative mb-4">
                            <v-select v-model="tr.transportId" :options="dicts.alertTransports" class="w-full" :clearable="false"
                                v-bind:class="{ 'select-error': !!errors[`alertTransports[${indextr}].TransportId`] }" label="name"
                                placeholder="Выберите чат" :reduce="opt => opt.id"
                                append-to-body @input="errors[`alertTransports[${indextr}].TransportId`] = ''" />
                            <div v-if="errors[`alertTransports[${indextr}].TransportId`]"
                                class="con-text-validation span-text-validation-danger vs-input--text-validation-span select-validation">
                                <span class="span-text-validation">
                                    {{ errors[`alertTransports[${indextr}].TransportId`][0] }}
                                </span>
                            </div>
                        </div> 
                    </vs-td>
                    <vs-td class="action-col">
                        <div v-if="!tr.required" class="inline-block cursor-pointer mt-2 mr-3 mb-4">
                            <feather-icon @click="deleteTransport(indextr)" icon="Trash2Icon"
                                class="inline-block text-danger" svgClasses="w-6 h-6" />
                        </div>
                    </vs-td> 
                </vs-tr>
                <vs-tr>
                    <vs-td>
                        <vs-button size="small" class="" @click="addNewTransport">
                            <feather-icon icon="PlusIcon" class="inline-block text-white" svgClasses="w-4 h-6" />
                        </vs-button>
                    </vs-td>
                    <vs-td></vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled">
            Сохранить
        </vs-button>

        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled">
            Отмена
        </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

export default {
    name: 'alerts-management-edit',
    props: ['id'],
    data() {
        return {
            form: {
                id: undefined,
                name: undefined,
                description: undefined,
                title: undefined,
                checkFrequency: undefined,
                checkPeriod: undefined,
                alertParams: [],
                alertTransports: [],
            },
            dicts: {
                alertParamUnits: [],
                alertTransports: []
            },
            errors: []
        }
    },
    components: {
        'v-select': vSelect
    },
    methods: {
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: `/alerts-management/${ this.id }`,
                method: 'GET',
                success: (data) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.form = data;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки данных для редактирования.',
                        color: 'danger'
                    });
                }
            });
        },
        loadDicts() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                url: 'alerts-management/dicts',
                method: 'GET',
                success: (dicts) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.dicts = dicts;
                },
                catch: (err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                }
            });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.$axios({
                method: 'PUT',
                url: `alerts-management/${ this.id }`,
                params: this.form,
                errors: this.errors,
                success: () => {
                    this.$vs.notify({
                        title: "Успешно",
                        text: "Алерт успешно отредактирован",
                        color: "success",
                    });
                    this.$router.push({ name: 'alerts-management' });
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors) {
                        this.errors = err.data.errors;
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: 'Ошибка валидации',
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при редактировании алерта!",
                        color: "danger",
                    });
                }
            })
        },

        addNewParam() {
            const newParam = {
                alertId: this.id,
                name: '',
                description: '',
                value: '',
                unitId: 1,
            };

            this.form.alertParams = [...this.form.alertParams, newParam];
        },
        deleteParam(fieldIndex) {
            this.form.alertParams.splice(
                this.form.alertParams.findIndex((i, index) => index === fieldIndex),
                1
            );
        },

        addNewTransport() {
            const newTransport = {
                alertId: this.id,
                transportId: 1
            };

            this.form.alertTransports = [...this.form.alertTransports, newTransport];
        },
        deleteTransport(fieldIndex) {
            this.form.alertTransports.splice(
                this.form.alertTransports.findIndex((i, index) => index === fieldIndex),
                1
            );
        },

        cancelEdit() {
            this.$router.push({ name: 'alerts-management' });
        }
    },
    mounted() {
        this.loadData();
        this.loadDicts();
    }
}
</script>

<style lang="scss">
</style>